import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import LearnGame from "../../components/LearnGamePhonics";
import ProgressBar from "../../components/ProgressBar";
//import PracticeGame from "../../components/PracticeGame";
//import KeyboardStage3 from "../../components/KeyboardStage3";
import Keyboard from "../../components/Keyboard";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';
import { Textfit } from 'react-textfit';
import axios from "axios";
//import useAuth from "../../../auth/hooks/useAuth";

import crosshair from "../../assets/Phonics/crosshair.png";
import ghost from "../../assets/Phonics/ghost.png";
import ghostblue from "../../assets/Phonics/ghost_blue.png";
import ghostgreen from "../../assets/Phonics/ghost_green.png";
import ghostred from "../../assets/Phonics/ghost_red.png";
import ghostyellow from "../../assets/Phonics/ghost_yellow.png";

var { questions } = [];
var { round3questions} = [];

var animatedRound4 = false;
var animatedRound5 = false;

export default function Game({ ...props }) {
   // const { state: authState } = useAuth();
    const [loading, setLoading] = useState(true);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [nofeedback, setNoFeedback] = useState([]);
    const [status, setStatus] = useState("LOADING");
    const [setup, setSetup] = useState(false);
    const [custom, setCustom] = useState(false);
    const [waitTime, setWaitTime] = useState(-10);
    const [endgame, setEndGame] = useState(false);

    const[showColouredFeedback, setColouredFeedback] = useState(false);

    const [refresh, setRefresh] = useState(false)
    //const {useTop} = useTopicQuestions();
    //console.log(loading);

    var timer = -1;
    if(props.timelimit > 0)
    {
        timer = props.timelimit;
    }
    else
    {
        timer = 300;
    }

    var questionMax = -1;
    if(props.minimum > 0)
    {
        questionMax = props.minimum;
    }

    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      }

    //console.log(props);
    if (setup == false) {
        questions = undefined;
        if (questions == undefined && props.customlist == undefined && setup == false) {
            var params = {
                topics: props.topics,
                game_type: "phonics"
            };
            try {
                (async () => {
                    const response = await axios({
                        method: "get",
                        url: `${process.env.REACT_APP_OAUTH_URL}/lite/topics/questions`,
                        params
                    });
                    setStatus("OK");
                    console.log(response.data);
                    //if more than 6 words
                    if (response.data.length > 6){
                      let usethese = response.data;
                      questions = [];
                      for (let i = 0; i < 6; i++) {
                        let ques = usethese[i];
                        questions.push(ques);
                        usethese.splice(i,1);
                      }
                      console.log(questions);
                    }else{
                      questions = response.data;
                    }
                    //round 3 12 questions
                    if (questions.length < 12){
                      round3questions = [];
                      for (let i = 0; i < questions.length; i++) {
                        let que = questions[i];
                        round3questions.push(que);
                      }
                      while (round3questions.length < 12){
                        let rquestion = questions[Math.floor(Math.random()*questions.length)];
                        round3questions.push(rquestion);
                      }
                    }else{
                      round3questions = questions;
                    }
                    console.log(round3questions);
                    
                })();
            } catch (e) {
                setStatus("ERROR");
            }
            setCustom(false);
            setSetup(true);
            //newQuestion();
        } else if (setup == false && props.customlist != undefined) {
            questions = [];
            var list = props.customlist;
            list.forEach(q => {
                var reg = new RegExp("\\b" + q.right_answer + "\\b", 'i');
                let questionText = q.question.replace(reg, "$");//do replacement thing
                let qobj = { "question_key": q.id, "sentence": questionText, "word": q.right_answer, "topic_key": q.id, "topic_id": q.id }
                questions.push(qobj);
            });
            setStatus("OK");
            setCustom(true);
            setSetup(true);
        }
    }

    //const { sayWord } = useSpeech();
    const [currentQuestion, setCurrentQuestion] = useState([]);
    const [wordToSay, setWordToSay] = useState("");
    const [extraChars, setExtraChars] = useState([]);
//NEW VARIABLES
    const[qnum, setQuestionNumber] = useState(-1);
    const [completedQuestions, setCompletedQuestions] = useState([]);
    const [wrongQuestions, setWrongQuestions] = useState([]);
    const [round, setRound] = useState(1);
    const [showWord, setShowWord] = useState(true);//whether to show the word or not
    const [wordTimer, setWordTimer] = useState(-10);//timer to hide the word
    const [showCompleteScreen, setShowCompleteScreen] = useState(false);//shows some round complete screen after each round

    const [inputLetters, setInputLetters] = useState([]);//this is an array of letters, it will have values of answer: and value:, when a new question is created it will create a blank array of it

    //PHONICS
    const [power, setPower] = useState(0);
    const [canShoot, setCanShoot] = useState(false);
    //crosshair positions
    const [crossX, setCrossX] = useState(0);
    const [crossY, setCrossY] = useState(0);
    //cursor positions
    const [cursorX, setCursorX] = useState(0);
    const [cursorY, setCursorY] = useState(0);
    //ghost stuff
    const [ghost1Level, setghostlevel1] = useState(0);
    const [ghost2Level, setghostlevel2] = useState(0);
    const [ghost3Level, setghostlevel3] = useState(0);
    const [ghost4Level, setghostlevel4] = useState(0);

    //round 2 stuff
    const [ghostText, setGhostText] = useState(0);

    //round 3 stuff
    const [ghostTimer, setGhostTimer] = useState(0);//this is the timer for the ghost appearing counts down
    const [ghostNumber, setGhostNumber] = useState(0);//this is the display value 0 = display ghost 1 and say word, 1 = display ghost 2 and say word, 2 = display both ghosts and can fire
    const [completedText, setCompletedText] = useState("");
    const [debugnum, setdebugnum] = useState(0);
    //round 4 stuff
    //const [ghostletterarray, setGhostLetters] = useState([]);
    const [answerLetters, setAnswerLetters] = useState([]);
    const [currentWord, setCurrentWord] = useState([]);

    //timer for showing the word
    useEffect(() => {
        if (wordTimer > 0) {
            var wordtimerID = setInterval(() => reduceWordTimer(), 1000);
            return () => {
                clearInterval(wordtimerID);
            };
        } else if (wordTimer != -10) {
            setShowWord(false);
        }
      },[wordTimer]);


    //POWER INCREASE for firing
    useEffect(() => {
      if (power < 100) {
          setCanShoot(false);
          var powerTimerid = setInterval(() => increasePower(), 20);
          return () => {
              clearInterval(powerTimerid);
          };
      } else if (power == 100) {
          setCanShoot(true);
      }
    },[power]);

    function increasePower() {
      setPower(power + 2);
    }


      function reduceWordTimer() {
        console.log(wordTimer);
        setWordTimer(wordTimer - 1);
      }

    function newQuestion() {
        console.log("new question");
        let tqnum = qnum+1;
        setQuestionNumber(tqnum);
        setQuestionNumber(tqnum);
        //needs a better check for when you have answered up to questions.length but don't have them all right, needs to go back and go to the first question that isn't included in teh completedquestions array
        //use effects to generate new question by generating a new question whenever tqnum changes?
    }

    useEffect(() => {
        console.log("qnum changed");
        if (status == "OK"){
                //check if completed already then increment again if completed already until greater than questions.length
                console.log("comparing lengths");
                console.log(qnum)
                console.log(questions.length);
                let qlength = questions.length;
                if (round == 3){
                  qlength = round3questions.length;
                }
            if (qnum < qlength){
              if (round != 3 && round != 4 && round != 5){
                if (completedQuestions.includes(questions[qnum].right_asnwer)){
                    console.log("completed questions contains it");
                    newQuestion();
                }else{
                    var sample = questions[qnum];
                    sample.answers = [];
                    sample.answers.push({correct: true, value: sample.right_answer});
                    sample.answers.push({correct: false, value: sample.wrong_answer_1, });
                    sample.answers = shuffleArray(sample.answers);

                    setCurrentQuestion(sample);
                    //check if wrong 6 times
                    console.log("COMPELTED:");
                    console.log(completedQuestions);
                    console.log("WRONG:");
                    console.log(wrongQuestions);
                     let wrongCount = 0;
                     for (let i = 0; i < wrongQuestions.length; i++) {
                       if (sample.right_answer ==  wrongQuestions[i]){
                         wrongCount++;
                       }
                     }
                     console.log(wrongCount);
                     if (wrongCount >= 6){
                      setCompletedQuestions([...completedQuestions, sample.right_answer]);
                     }
                }
              }else if (round == 3){
                var sample = round3questions[qnum];
                sample.answers = [];
                sample.answers.push({correct: true, value: sample.right_answer});
                sample.answers.push({correct: false, value: sample.wrong_answer_1, });

                sample.answers = shuffleArray(sample.answers);
                let comptext = completedQuestions.length + "/" +round3questions.length;
                setCompletedText(comptext);

                setdebugnum(debugnum+1);
                setCurrentQuestion(sample);
                //setGhostTimer(3);
                //check if wrong 6 times
                console.log("COMPELTED:");
                console.log(completedQuestions);
                console.log("WRONG:");
                console.log(wrongQuestions);
                console.log(sample);//current question
                console.log(qnum);
                setGhostNumber(0);
                //setGhostTimer(0);
                  let wrongCount = 0;
                  for (let i = 0; i < wrongQuestions.length; i++) {
                    if (sample.right_answer ==  wrongQuestions[i]){
                      wrongCount++;
                    }
                  }
                  console.log(wrongCount);
                  if (wrongCount >= 6){
                  setCompletedQuestions([...completedQuestions, sample.right_answer]);
                  }
              }

              //ROUND 4
              else if (round == 4 || round == 5){
                var sample = questions[qnum];
                sample.answers = [];
                sample.answers.push({correct: true, value: sample.right_answer});
                sample.answers.push({correct: false, value: sample.wrong_answer_1, });

                sample.answers = shuffleArray(sample.answers);
                let comptext = completedQuestions.length + "/" +questions.length;
                setCompletedText(comptext);
                console.log("COMPLETED TEXT:");
                console.log(comptext);

                //WORD STUFF
                let wordasarray = sample.right_answer.split("");
                let realarray = [];
                //set all blank apart from last letter
                for (let i = 0; i < wordasarray.length; i++) {
                  let letter = wordasarray[i];
                  if (i == wordasarray.length-1 && wordasarray.length != 1 && round == 4){
                    realarray.push(letter);
                  }else{
                    realarray.push("_");
                  }
                }
                setCurrentWord(realarray);//sets the word array to that with the underscores
                sayWord(sample.right_answer);

                console.log(wordasarray);
                console.log(realarray);

                let tempanswerletters = [];
                let correctLetter = {letter: wordasarray[0], correct: true}
                tempanswerletters.push(correctLetter);
                //do the first lot of answer letters
                for (let i = 0; i < 3; i++) {
                  let wrongLetter = {letter: GetRandomWrongLetter(wordasarray[0]), correct: false};
                  tempanswerletters.push(wrongLetter);         
                }
                setAnswerLetters(tempanswerletters);
                console.log(tempanswerletters);
                console.log(answerLetters);

                setAnswerLetters(shuffleArray(tempanswerletters));//shuffles the array
                
                
                setCurrentQuestion(sample);
                //setGhostTimer(3);
                if (round == 4){
                  setGhostNumber(4);
                }
                else if (round == 5){
                  setGhostNumber(5);
                }

                //check if wrong 6 times
                console.log("COMPELTED:");
                console.log(completedQuestions);
                console.log("WRONG:");
                console.log(wrongQuestions);
                console.log(sample);//current question
                console.log(qnum);
                  let wrongCount = 0;
                  for (let i = 0; i < wrongQuestions.length; i++) {
                    if (sample.right_answer ==  wrongQuestions[i]){
                      wrongCount++;
                    }
                  }
                  console.log(wrongCount);
                  if (wrongCount >= 6){
                  setCompletedQuestions([...completedQuestions, sample.right_answer]);
                  }
              }
            }
            else{
                console.log("qnum is greater");
                setQuestionNumber(0);
            }
        }
    }, [qnum]);

    function GetRandomWrongLetter(correctLetter){
      var characters  = 'abcdefghijklmnopqrstuvwxyz';
      let result = characters.charAt(Math.floor(Math.random() * characters.length));
      if (result == correctLetter){
        return GetRandomWrongLetter(result);
      }else{
        return result;
      }
    }

    useEffect(() => {
        if (status == "OK"){
          let qlength = questions.length;
          if (round == 3){
            qlength = round3questions.length;
          }
          console.log("QLENGTH = " + qlength)
            if (completedQuestions.length != qlength){
                newQuestion();
            }else{
                CheckRoundSystem();
            }
        }
    }, [completedQuestions]);

    

    //will check if each question is completed of that round, otherwise populate the question list with ones not correct yet
    function CheckRoundSystem(){
        console.log("checking round system");
        console.log(completedQuestions);
        console.log(questions);

        let qlength = questions.length;
          if (round == 3){
            qlength = round3questions.length;
          }
        
        if (completedQuestions.length == qlength){
          if (round == 3){
            setCompletedText(round3questions.length + "/" + round3questions.length);
          }
          if (round == 4){
            setCompletedText(questions.length + "/" + questions.length);
          }
            //next round
            if (round != 5){
              setShowCompleteScreen(true);
            }else{
              setEndGame(true);
            }
            
        }else{
            setQuestionNumber(0);
            newQuestion();
        }
    }

    function NextRound(){
            setShowCompleteScreen(false);
            setCompletedQuestions([]);//blank this array
            setWrongQuestions([]);
            setRound(round+1);

            //clear some stuff up
            setghostlevel1(0);
            setghostlevel2(0);
            setghostlevel3(0);
            setghostlevel4(0);
            //more stuff
            if (round == 4){
              setGhostNumber(4);
            }
            if (round == 5){
              setGhostNumber(5);
            }

            console.log("ROUND COMPLETED");
            console.log(round);
            setQuestionNumber(0);
    }


    //Called on click
  async function checkResultRound1(value, callback) {
    console.log(value);
    var isCorrect = true;
    if (value.correct == true) {
      setCompletedQuestions([...completedQuestions, value.value]);
      //console.log(value.value + " " + currentQuestion.right_answer);
      //correct answer
      //setCorrectQuestions([...correctQuestions, currentQuestion]);
      let multiplier = combo > 0 ? combo + 1 : 1;
      multiplier = multiplier > 5 ? 5 : multiplier;
      setScore(score + multiplier * 10);

      if (combo < 99) {
        setCombo(combo + 1);
      }
      if (combo > maxCombo) {
        setMaxCombo(combo);
      }

      //moved this into a useeffect
      //newQuestion();
    }
    //incorrect answer
    else {
      isCorrect = false;
      setWrongQuestions([...wrongQuestions, currentQuestion.right_answer]);
      //setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
      if (combo === 0 && score >= 10) {
        setScore(score - 10);
      } else {
        setCombo(0);
      }


      //setFeedback([...feedback, result]);
      setColouredFeedback(true);
      setWaitTime(2);
    }

    //Generates a new question
    //newQuestion();
  }

    //     set the first question
    useEffect(() => {
        console.log("USE EFFECT HAPPENS");
        console.log(questions);
        if (questions !== undefined && questions.length > 0) {
            console.log("set the first question");
            //setCurrentQuestion(questions[0]);
            newQuestion();
            setWordToSay(currentQuestion.right_answer);
            console.log(currentQuestion);
            setLoading(false);
        }
    }, [status]);



    //when question changes play the relevant audio

    
    useEffect(() => {
      console.log("CURRENT QUESTION CHANGED");
      if (round == 1){
        sayWord(currentQuestion.right_answer);
      }
      if (round == 3 && debugnum == 0){
        console.log("setting ghost timer");
        sayWord(currentQuestion.right_answer);
        setGhostTimer(3);
      }
    }, [currentQuestion]);

    useEffect(() => {
      console.log("DEBUG NUM QUESTION CHANGED");

      if (round == 3){
        console.log("setting ghost timer");
        sayWord(currentQuestion.right_answer);
        setGhostTimer(3);
      }
    }, [debugnum]);

    useEffect(() => {
      if (round == 3){
        if (ghostNumber == 0 && ghostTimer >= 0) {//show first ghost
          console.log("show first ghost");
            var ghostimerid = setInterval(() => decreaseGhostTimer(), 1000);
            return () => {
                clearInterval(ghostimerid);
            };
        }
        if (ghostNumber == 0 && ghostTimer < 0){
          console.log("show second ghost and say second word");
          sayWord(currentQuestion.wrong_answer_1);
          setGhostNumber(1);//display 2nd
          setGhostTimer(3);
        }
        if (ghostNumber == 1 && ghostTimer > 0){
          var ghostimerid = setInterval(() => decreaseGhostTimer(), 1000);
          return () => {
              clearInterval(ghostimerid);
          };
        }
        if (ghostNumber == 1 && ghostTimer <= 0){
          setGhostNumber(2);//display both
          setGhostTimer(1);
          var ghostimerid = setInterval(() => decreaseGhostTimer(), 1000);
          console.log("show both ghosts");
          return () => {
            clearInterval(ghostimerid);
        };
        }
      }
    },[ghostTimer]);

    useEffect(() => {
      if (ghostNumber == 2 && round == 3){
        ClearAllTimeouts();
        AnimateGhost("ghost10");
        AnimateGhost("ghost20");
      }
      if (ghostNumber == 4 && round == 4 && animatedRound4 == false){
        //ClearAllTimeouts();
        animatedRound4 = true;
        AnimateGhost("ghost100");
        AnimateGhost("ghost200");
        AnimateGhost("ghost300");
        AnimateGhost("ghost400");
      }
      if (ghostNumber == 5 && round == 5 && animatedRound5 == false){
        //ClearAllTimeouts();
        animatedRound5 = true;
        //AnimateGhost("ghost100");
        //AnimateGhost("ghost200");
        //AnimateGhost("ghost300");
        //AnimateGhost("ghost400");
      }
  }, [ghostNumber]);

  function ClearAllTimeouts(){
    console.log("clearing all timeouts");
    var id = window.setTimeout(function() {}, 0);

    while (id--) {
        window.clearTimeout(id); // will do nothing if no timeout with id is present
    }
  }

  var timeOuts = [];

  const AnimateGhost = ($id) => {
    let target = document.getElementById($id);
    //console.log(target);
    if (target != null){
      target.style.position = "absolute";
      let newtop = parseInt(target.style.top) + getRandomArbitrary(-2,2);
      let newleft = parseInt(target.style.left) + getRandomArbitrary(-2,2);
      newtop = Math.min(Math.max(parseInt(newtop), 15), 75);
      newleft = Math.min(Math.max(parseInt(newleft), 15), 75);
      target.style.top = newtop + '%'
      target.style.left = newleft + '%'
      //console.log(target.style.top);
    }
    
    setTimeout(() => {
      let v = AnimateGhost($id);
      timeOuts.push(v);
  }, 1500)
  //var id = setTimeout(AnimateGhost($id), 2500);
  //timeOuts.push(id);
}

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

    function decreaseGhostTimer() {
        console.log("ghost timer decreasing : " + ghostTimer);
      setGhostTimer(ghostTimer - 1);
    }

    /*
    useEffect(() => {
        sayWord(wordToSay);
    }, [wordToSay]);*/

    function ComboImage() {
        var imageName = props.gameData.animation_path + "/Learn/";

        if (round == 1 && showCompleteScreen == false){
          imageName+= "round1.gif";
        }
        else if (round == 1 && showCompleteScreen == true){
          imageName+= "transition1.gif";
        }
        else if (round == 2 && showCompleteScreen == false){
          imageName+= "round2.gif"
        }
        else if (round == 2 && showCompleteScreen == true){
          imageName+= "transition2.gif"
        }
        else if (round == 3 && showCompleteScreen == false){
          imageName+= "round3.gif";
        } else if (round == 3 && showCompleteScreen == true){
          imageName+= "transition3.gif";
        } else if (round == 4 && showCompleteScreen == false){
          imageName+= "round4.gif";
        }
        else if (round == 4 && showCompleteScreen == true){
          imageName+= "transition4.gif";
        }
        else if (round == 5 && showCompleteScreen == false){
          imageName+= "round5.gif";
        }

        //return <img src= {{imageName}} style={{position:"relative"}}></img>
        //console.log("../../assets/" + imageName)
        return (require("../../assets/" + imageName))
    }

    useEffect(() => {
        if (waitTime > 0) {
            var waitttimerID = setInterval(() => reduceTimer(), 1000);
            return () => {
                clearInterval(waitttimerID);
            };
        } else if (waitTime != -10) {
            setColouredFeedback(false);
            newQuestion();
        }
      },[waitTime]);

      function reduceTimer() {
        console.log(waitTime);
      setWaitTime(waitTime - 1);
      }

      function FilteredAnswers() {
        if (currentQuestion.answers != undefined) {
          return currentQuestion.answers.filter(v => v.value !== "");
        }
        return currentQuestion;
      }

    //console.log(props);
    //console.log("CURRENTQUESTION");
    //console.log(currentQuestion);

    //return the word
    function ReturnWord(){
        console.log(currentQuestion);
        if (currentQuestion.right_answer != undefined){
            if (showWord){
                return currentQuestion.right_answer;
            }else{
                let blanks = "";
                for (let i = 0; i < currentQuestion.right_answer.length; i++) {
                    blanks+= "-";
                }
                return blanks;
            }
        }else{
            return "";
        }
    }

    function GetGhostColour(ghostlevel){
      if (ghostlevel == 0){
        return ghostred;
      }
      else if (ghostlevel == 1){
        return ghostyellow;
      }
      else if (ghostlevel == 2){
        return ghostgreen;
      }
      else if (ghostlevel == 3){
        return ghost;
      }
      else if (ghostlevel == 99){
        return ghostblue;
      }
    }

    function ReturnGhosts(){
      if (round == 0){
        return <div></div>
      }
      if (round == 1){
        return (
          <div id= "ghost1" style={{pointerEvents: "none", userSelect: "none", position:"relative", top: "15%", left: "50%", display: "flex", alignItems: "center"}}>
            <img draggable="false" src={GetGhostColour(ghost1Level)}/>
            <CenteredText>{currentQuestion.right_answer}</CenteredText>
          </div>
          
        );
      }
      if (round == 2){
        //sayWord(currentQuestion.right_answer);
        return (
          <div id= "ghost1" style={{pointerEvents: "none", userSelect: "none", position:"relative", top: "15%", left: "50%", display: "flex", alignItems: "center"}}>
            <img draggable="false" src={GetGhostColour(ghost1Level)}/>
            <CenteredText id="round2text">{Round2Word()}</CenteredText>
          </div>
        );
      }
      if (round == 3){
        if (ghostNumber == 0){
          return (
            <div id= "ghost1" style={{pointerEvents: "none", userSelect: "none", position:"relative", top: "15%", left: "40%", display: "flex", alignItems: "center"}}>
              <img draggable="false" src={GetGhostColour(0)}/>
              <CenteredText  id="round2text">🔊</CenteredText>
            </div>
          );
        } else if (ghostNumber == 1){
          return (
            <div id= "ghost2" style={{pointerEvents: "none", userSelect: "none", position:"relative", top: "15%", left: "60%", display: "flex", alignItems: "center"}}>
              <img draggable="false" src={GetGhostColour(99)}/>
              <CenteredText  id="round2text">🔊</CenteredText>
            </div>
          );
        }
        else if (ghostNumber == 2){
          return (
            <div>
              <div id= "ghost10" style={{ cursor: "pointer", userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "15%", left: "70%", display: "flex", alignItems: "center"}}>
                <img onClick={() => sayWord(currentQuestion.right_answer)} draggable="false" src={GetGhostColour(0)}/>
                <CenteredText style={{left: "-54%"}} onClick={() => sayWord(currentQuestion.right_answer)} id="round2text">🔊</CenteredText>
              </div>
              <div id= "ghost20" style={{cursor: "pointer", userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "15%", left: "40%", display: "flex", alignItems: "center"}}>
              <img onClick={() => sayWord(currentQuestion.wrong_answer_1)} draggable="false" src={GetGhostColour(99)}/>
              <CenteredText style={{left: "-54%"}} onClick={() => sayWord(currentQuestion.wrong_answer_1)} id="round2text">🔊</CenteredText>
            </div>
           </div>
          );
        }
      }

      if (round == 4){
        return (
          <div>
            <div id= "ghost100" data-word={GetGhostLetter(0)} data-value={GetGhostLetterValue(0)} style={{ userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "12%", left: "15%", display: "flex", alignItems: "center"}}>
              <img draggable="false" src={GetGhostColour(0)}/>
              <CenteredText style={{left: "-54%"}} >{GetGhostLetter(0)}</CenteredText>
            </div>
            <div id= "ghost200" data-word={GetGhostLetter(1)} data-value={GetGhostLetterValue(1)} style={{userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "20%", left: "40%", display: "flex", alignItems: "center"}}>
            <img draggable="false" src={GetGhostColour(1)}/>
            <CenteredText style={{left: "-54%"}} >{GetGhostLetter(1)}</CenteredText>
            </div>
            <div id= "ghost300" data-word={GetGhostLetter(2)} data-word={GetGhostLetter(1)} data-value={GetGhostLetterValue(2)} style={{userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "10%", left: "60%", display: "flex", alignItems: "center"}}>
            <img draggable="false" src={GetGhostColour(2)}/>
            <CenteredText style={{left: "-54%"}} >{GetGhostLetter(2)}</CenteredText>
            </div>
            <div id= "ghost400" data-word={GetGhostLetter(3)} data-value={GetGhostLetterValue(3)} style={{userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "22%", left: "75%", display: "flex", alignItems: "center"}}>
            <img draggable="false" src={GetGhostColour(99)}/>
            <CenteredText style={{left: "-54%"}} >{GetGhostLetter(3)}</CenteredText>
            </div>
         </div>
        );
      }

      if (round == 5){
        return (
          <div>
            <div id= "ghost100" data-word={GetGhostLetter(0)} data-value={GetGhostLetterValue(0)} style={{ userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "12%", left: "15%", display: "flex", alignItems: "center"}}>
              <img draggable="false" src={GetGhostColour(0)}/>
              <CenteredText style={{left: "-54%"}} >{GetGhostLetter(0)}</CenteredText>
            </div>
            <div id= "ghost200" data-word={GetGhostLetter(1)} data-value={GetGhostLetterValue(1)} style={{userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "20%", left: "40%", display: "flex", alignItems: "center"}}>
            <img draggable="false" src={GetGhostColour(1)}/>
            <CenteredText style={{left: "-54%"}} >{GetGhostLetter(1)}</CenteredText>
            </div>
            <div id= "ghost300" data-word={GetGhostLetter(2)} data-word={GetGhostLetter(1)} data-value={GetGhostLetterValue(2)} style={{userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "10%", left: "60%", display: "flex", alignItems: "center"}}>
            <img draggable="false" src={GetGhostColour(2)}/>
            <CenteredText style={{left: "-54%"}} >{GetGhostLetter(2)}</CenteredText>
            </div>
            <div id= "ghost400" data-word={GetGhostLetter(3)} data-value={GetGhostLetterValue(3)} style={{userSelect: "none", transition:"all 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", top: "22%", left: "75%", display: "flex", alignItems: "center"}}>
            <img draggable="false" src={GetGhostColour(99)}/>
            <CenteredText style={{left: "-54%"}} >{GetGhostLetter(3)}</CenteredText>
            </div>
         </div>
        );
      }
    }

    function GetGhostLetter(pos){
      if (answerLetters.length == 0){
        return "";
      }else{
        return answerLetters[pos].letter;
      }
    }

    function GetGhostLetterValue(pos){
      if (answerLetters.length == 0){
        return false;
      }else{
        return answerLetters[pos].correct;
      }
    }

    //gets the text to display with the correct colouring
    function Round2Word(){
      //console.log("round 2 word");
      //return the round2 word with all the correct formatting
      //parse wrong_answer 2
      let parseme = currentQuestion.wrong_answer_2;
      //console.log(parseme);
      //split it by 
      parseme = parseme.split("|");
      //get what level the player is on and display those letters in the array as green
      if (ghost1Level < Round2Length()){
        let letters = parseme[ghost1Level].split(",");
        let editedDisplay = "";
        for (let i = 0; i < currentQuestion.right_answer.length; i++) {
          const letter = currentQuestion.right_answer[i];
          if (letters.includes(String(i+1))){
            editedDisplay += '<span style="color: green;">'+letter+'</span>';
          }else{
            editedDisplay += '<span style="color: red;">'+letter+'</span>';
          }
        }
        //console.log(editedDisplay);
        //document.getElementById("round2text").innerHTML.replace(editedDisplay);//replace the text

        return (
        <div
        dangerouslySetInnerHTML={{__html: editedDisplay}}
        />
        );
      }else{
        return <div></div>
      }
      

    }

    function Round2Length(){
      let parseme = currentQuestion.wrong_answer_2;
      //console.log("Round length=" + parseme.split("|").length)
      return  parseme.split("|").length;
    }

    function GetCurrentSound(){
      let parseme = currentQuestion.wrong_answer_3;
      console.log("sound to split= " + currentQuestion.wrong_answer_3)
      parseme = parseme.split("|");
      console.log('parsed = ' + parseme);
      console.log("ghost level " + ghost1Level)
      console.log("current sound= " + parseme[ghost1Level]);

      return parseme[ghost1Level+1];//should be the sound
    }

    function sayWord(word){
      if (round == 2){
        //use the split up ones
        word = GetCurrentSound();
      }
     if (word != undefined && word != "") {
        word = word.toLowerCase();
        console.log("playing sound: " + word);
        try {
            // Updated to use the public folder path
            var audio = new Audio("/audio/" + word + '.mp3'); 
            audio.play();
        } catch (error) {
            var msg = new SpeechSynthesisUtterance();
            msg.text = word;
            window.speechSynthesis.speak(msg);
        }
    }
    }

    function playSound(sound){
      if (sound != undefined && sound != ""){
        var audio = new Audio(require("../../assets/Audio/" + sound));
        audio.play();
      }
    }

    function ClickAnywhere(event){
      //console.log(cursorX + "|" + cursorY);
      //setCrossX(cursorX-61.5);
      //setCrossY(cursorY-61.5);
    }


    function ReturnCursor(){

      //var transformValue = "translate3d("+crossX+"px,"+crossY+"px,0)";
      //console.log(transformValue);
      return (
        <div id="crosshair" style={{pointerEvents: "none", zIndex: "1", userSelect: "none", transition:"transform 1s cubic-bezier(.02,1.23,.79,1.08)", position:"absolute", display: "flex", alignItems: "center"}}>
          <img draggable="false" src={crosshair}/>
        </div>
      )
    }

    function getBoundingBox (element) {
      if (element == undefined){
        return null;
      }
      const box = element.getBoundingClientRect()
      const ret = { }
    
      // Loops through all DomRect properties.
      // Cannot spread because they're not enumerable.
      for (const prop in box) {
        ret[prop] = box[prop]
      }
    
      ret.x = box.left;
      ret.y = (box.top + box.bottom) / 2
    
      return ret
    }

    function Fire(){
      //compare ghost positions to cursor position +/- 175 pixels
      if (power < 100)
        return;
      if (round == 1 || round == 2){
        let ghost = getBoundingBox(document.getElementById("ghost1"));
        let crosshair = getBoundingBox(document.getElementById("crosshair"));
        if (ghost == null){
          return;
        }
        //get x diff and y diff
        let xdiff = Math.abs(ghost.x - crosshair.x);
        let ydiff = Math.abs(ghost.y - crosshair.y);
        console.log("X="+xdiff);
        console.log("Y="+ydiff);
        if (xdiff < 60 && ydiff < 95){
          console.log("YOU HIT THE GHOST");
          //increase ghost hit count
          setghostlevel1(ghost1Level+1);
          setPower(0);
          
          if (round == 1){
            //if ghost level is greater than 4 then next question
            if (ghost1Level >= 2){
              console.log(ghost1Level);
              console.log("completed question");
              setCompletedQuestions([...completedQuestions, currentQuestion.right_answer]);
              setghostlevel1(0);
            }else{
              //make the ghost play a noise
              sayWord(currentQuestion.right_answer);
            }
        } else if (round == 2){
          if (ghost1Level >= Round2Length()-1){
            console.log(ghost1Level);
            console.log("completed question");
            setCompletedQuestions([...completedQuestions, currentQuestion.right_answer]);
            setghostlevel1(0);
          }else{
            //make the ghost play a noise
            sayWord(currentQuestion.right_answer);
          }
        }

          setScore(score + 10);
        }else{
          console.log("MISS");
          setPower(0);
        }
      }

      else if (round == 3 && ghostNumber == 2){
        console.log("FIRE");
        let ghost1 = getBoundingBox(document.getElementById("ghost10"));
        let ghost2 = getBoundingBox(document.getElementById("ghost20"));
        let crosshair = getBoundingBox(document.getElementById("crosshair"));

        setPower(0);

        //see which ghost you are close to
        if (ghost1 == null){
          return;
        }

        let xdiff = Math.abs(ghost1.x - crosshair.x);
        let ydiff = Math.abs(ghost1.y - crosshair.y);
        //close to first ghost
        if (xdiff < 60 && ydiff < 95){
          //hit the ghost
            //playSound("5OK.wav");
            console.log(ghost1Level);
            console.log("completed question");
            setCompletedQuestions([...completedQuestions, currentQuestion.right_answer]);
            setCorrectQuestions([...correctQuestions, currentQuestion]);

            let result = {
              question: currentQuestion.right_answer,
              correct: currentQuestion.right_answer,
              incorrect: currentQuestion.right_answer
          };
          setNoFeedback([...nofeedback, result]);

            setghostlevel1(0);
            setghostlevel2(0);
            setScore(score + 20);
        }

        //if close to second ghost
          xdiff = Math.abs(ghost2.x - crosshair.x);
          ydiff = Math.abs(ghost2.y - crosshair.y);
          if (xdiff < 60 && ydiff < 95){
            playSound("6WRONG.wav");
            setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
            setWrongQuestions([...wrongQuestions, currentQuestion.word]);
            setScore(score - 20);
            let result = {
                question: currentQuestion.right_answer,
                correct: currentQuestion.right_answer,
                incorrect: currentQuestion.wrong_answer_1
            };
            setFeedback([...feedback, result]);
              setghostlevel1(0);
              setghostlevel2(0);
              newQuestion();
        }
      }

      else if (round == 4 || round == 5){
        setPower(0);
        let crosshair = getBoundingBox(document.getElementById("crosshair"));
        let ghost = GetClosestGhost4(crosshair);
        if (ghost != undefined){//if theres a ghost there
          //check if ghost is correct letter or not
          CheckAnswer4(ghost);
        }
      }
    }

    function GetClosestGhost4(crosshair){
          let ghost1 = getBoundingBox(document.getElementById("ghost100"));
          let xdiff = Math.abs(ghost1.x - crosshair.x);
          let ydiff = Math.abs(ghost1.y - crosshair.y);
          if (xdiff < 60 && ydiff < 95){
            return document.getElementById("ghost100");
          }

          let ghost2 = getBoundingBox(document.getElementById("ghost200"));
          xdiff = Math.abs(ghost2.x - crosshair.x);
          ydiff = Math.abs(ghost2.y - crosshair.y);
          if (xdiff < 60 && ydiff < 95){
            return document.getElementById("ghost200");
          }
          let ghost3 = getBoundingBox(document.getElementById("ghost300"));
          xdiff = Math.abs(ghost3.x - crosshair.x);
          ydiff = Math.abs(ghost3.y - crosshair.y);
          if (xdiff < 60 && ydiff < 95){
            return document.getElementById("ghost300");
          }
          let ghost4 = getBoundingBox(document.getElementById("ghost400"));
          xdiff = Math.abs(ghost4.x - crosshair.x);
          ydiff = Math.abs(ghost4.y - crosshair.y);
          if (xdiff < 60 && ydiff < 95){
            return document.getElementById("ghost400");
          }

          return undefined;
    }


    //completed letter add it to the array and then generate the next ones
    function CheckAnswer4(element){
      console.log(element);
      console.log(element.dataset.value);
      if (element.dataset.value == true || element.dataset.value == "true"){
        console.log("CORRECT LETTER");
            setScore(score + 20);
            playSound("5OK.wav");
            NextLetters();
        }

        else{
        //if the letter is wrong remove the ghost
            playSound("6WRONG.wav");
            setScore(score - 20);
            element.style.display = "none";
      }
    }

    function NextLetters(){
      //generate the next letters based on which ones are _
      let nextLetterId = -1;
      let tempWord = currentWord;
      
      for (let i = 0; i < currentWord.length; i++) {
        let letter = currentWord[i];
        if (letter == "_" && nextLetterId == -1){
          nextLetterId = i;
        }
      }
      //if there is another _ in the word
      if (nextLetterId != -1){
        console.log("THERE ARE MORE UNDERSCORES");
        tempWord[nextLetterId] = currentQuestion.right_answer.split("")[nextLetterId];//fill in the gap
        console.log(tempWord[nextLetterId])
        console.log(currentQuestion.right_answer.split("")[nextLetterId]);
        setCurrentWord(tempWord);
        console.log("SETTING THE WORD NOW TO " + tempWord);

        nextLetterId = -1;
        for (let i = 0; i < tempWord.length; i++) {
          let letter = tempWord[i];
          if (letter == "_" && nextLetterId == -1){
            nextLetterId = i;
          }
        }
        console.log(nextLetterId);

        if (nextLetterId != -1){
          let wordasarray = tempWord;
          let tempanswerletters = [];
          console.log(currentQuestion.right_answer[nextLetterId]);//the next letter to fill in
          let correctLetter = {letter: currentQuestion.right_answer[nextLetterId], correct: true}
          tempanswerletters.push(correctLetter);
          //do the first lot of answer letters
          for (let i = 0; i < 3; i++) {
            let wrongLetter = {letter: GetRandomWrongLetter(currentQuestion.right_answer[nextLetterId]), correct: false};
            tempanswerletters.push(wrongLetter);         
          }
          setAnswerLetters(tempanswerletters);
          console.log(tempanswerletters);
          console.log(tempWord);
    
          setAnswerLetters(shuffleArray(tempanswerletters));//shuffles the array

          //reset the ghosts
          setCrossX(0);
          document.getElementById("ghost100").style.display = "flex";
          document.getElementById("ghost200").style.display = "flex";
          document.getElementById("ghost300").style.display = "flex";
          document.getElementById("ghost400").style.display = "flex";
          document.getElementById("ghost100").style.left = '10%'
          document.getElementById("ghost200").style.left = '24%'
          document.getElementById("ghost300").style.left = '40%'
          document.getElementById("ghost400").style.left = '60%'
        }else{
          console.log("NO MORE LETTERS");
            setCompletedQuestions([...completedQuestions, currentQuestion.right_answer]);
          setGhostNumber(3);
          setAnswerLetters([]);
          setCurrentWord([]);
          //newQuestion();

          document.getElementById("ghost100").style.display = "flex";
          document.getElementById("ghost200").style.display = "flex";
          document.getElementById("ghost300").style.display = "flex";
          document.getElementById("ghost400").style.display = "flex";
          document.getElementById("ghost100").style.left = '10%'
          document.getElementById("ghost200").style.left = '24%'
          document.getElementById("ghost300").style.left = '40%'
          document.getElementById("ghost400").style.left = '60%'
        }


      }else{//next question
        /*
        console.log("NO MORE LETTERS");
        setCompletedQuestions([...completedQuestions, currentQuestion.right_answer]);
        setGhostNumber(3);
        setAnswerLetters([]);
        setCurrentWord([]);
        newQuestion();*/
        
      }
     

    }

    function GetRound4Word(){
      return currentWord.join('');
    }

    
    useEffect(() => {
      if (round == 2 && ghost1Level == 0){
        sayWord(currentQuestion.right_answer);
      }
  }, [ghost1Level]);

    var mouseIsDown = false;
    var intervalID;

    useEffect(() => {
      document.addEventListener('mousedown', function(event){
          mouseIsDown = true;
          setTimeout(function() {
            if(mouseIsDown) {
              //intervalID = setInterval(ClickAnywhere(event), 500);
              intervalID = setInterval(() => ClickAnywhere(event), 250);
              //cursorX = event.clientX;
              //cursorY = event.clientY;
              // mouse was held down
              var x = event.clientX;
              var y = event.clientY;
              var newposX = x - 250;
              var newposY = y - 200; 
              var cursorElement = document.getElementById("crosshair");
              if (cursorElement != null){
                cursorElement.style.transform = "translate3d("+newposX+"px,"+newposY+"px,0px)";
              }
            }
          }, 1000);
        });
        document.addEventListener('mouseup', function(event){
          mouseIsDown = false;
          if (intervalID != null){
            clearInterval(intervalID);
          }
        });

        document.onmousemove = function(event)
        {
          if (mouseIsDown == true && power >= 100 ){
            var cursorElement = document.getElementById("crosshair");
            //console.log(getBoundingBox(cursorElement));
                //setCursorX(event.clientX);
                //setCursorY(event.clientY);
                var x = event.clientX;
                var y = event.clientY;
                var newposX = x - 250;
                var newposY = y - 200; 
                
                if (cursorElement != null){
                  cursorElement.style.transform = "translate3d("+newposX+"px,"+newposY+"px,0px)";
                }
          }
        }
    });

    return (
        <div>
            {round == 1 &&
             <LearnGame
             parent={props}
             correct={correctQuestions}
             incorrect={incorrectQuestions}
             score={score}
             defaultTimer={timer}
             questionLimit={questionMax}
             onBack={() => props.onBack()}
             loading={loading}
             feedback={feedback}
             questionFontSize="0.7em"
             restart={() => {
               setCombo(0);
               setScore(0);
               setCorrectQuestions([]);
               setIncorrectQuestions([]);
             }}
             homework_id={props.homework_id}
           >
             <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
               {showCompleteScreen == true &&
            <CompleteScreen>
                <Textfit mode="single" style={{height: "100%"}}>
                Round {round} Complete!
                </Textfit>
                <Button  onClick={() => NextRound()}>  <Textfit mode="single" style={{height: "100%"}}> Continue </Textfit></Button>
            </CompleteScreen>
            }
            {showCompleteScreen == false &&
                 <Body updater={crossX}>
                   <div style={{ width: "80%" }}>
                   <ProgressBar percentage={power} />
                   <Button style={{position: "absolute", right: "0.5%", top: "55%", width: "200px", height: "80px", textAlign: "center", fontSize: "50px"}}onClick={() => Fire()}>FIRE</Button>
                   
                    {ReturnCursor()}
                      {ReturnGhosts()}
                  
                     {currentQuestion != undefined ? (
                       <Container update={refresh}>
                         
                       </Container>
     
                     ) : <h1>blank</h1>}
                   </div>
                 </Body>
            }
             </div>
           </LearnGame>
            }

{round == 2 &&
             <LearnGame
             parent={props}
             correct={correctQuestions}
             incorrect={incorrectQuestions}
             score={score}
             defaultTimer={timer}
             questionLimit={questionMax}
             onBack={() => props.onBack()}
             loading={loading}
             feedback={feedback}
             questionFontSize="0.7em"
             restart={() => {
               setCombo(0);
               setScore(0);
               setCorrectQuestions([]);
               setIncorrectQuestions([]);
             }}
             homework_id={props.homework_id}
           >
             <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
               {showCompleteScreen == true &&
            <CompleteScreen>
                <Textfit mode="single" style={{height: "100%"}}>
                Round {round} Complete!
                </Textfit>
                <Button  onClick={() => NextRound()}>  <Textfit mode="single" style={{height: "100%"}}> Continue </Textfit></Button>
            </CompleteScreen>
            }
            {showCompleteScreen == false &&
                 <Body updater={crossX}>
                   <div style={{ width: "80%" }}>
                   <ProgressBar percentage={power} />
                   <Button style={{position: "absolute", right: "0.5%", top: "55%", width: "200px", height: "80px", textAlign: "center", fontSize: "50px"}}onClick={() => Fire()}>FIRE</Button>
                   
                    {ReturnCursor()}
                      {ReturnGhosts()}
                  
                     {currentQuestion != undefined ? (
                       <Container update={refresh}>
                         
                       </Container>
     
                     ) : <h1>blank</h1>}
                   </div>
                 </Body>
            }
             </div>
           </LearnGame>
}

{round == 3 &&
                    <LearnGame
                    parent={props}
                    correct={correctQuestions}
                    incorrect={incorrectQuestions}
                    score={score}
                    defaultTimer={timer}
                    questionLimit={questionMax}
                    completedAmount={completedText}
                    onBack={() => props.onBack()}
                    loading={loading}
                    feedback={feedback}
                    questionFontSize="0.7em"
                    restart={() => {
                      setCombo(0);
                      setScore(0);
                      setCorrectQuestions([]);
                      setIncorrectQuestions([]);
                    }}
                    homework_id={props.homework_id}
                  >
                    <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                      {showCompleteScreen == true &&
                   <CompleteScreen>
                       <Textfit mode="single" style={{height: "100%"}}>
                       Round {round} Complete!
                       </Textfit>
                       <Button  onClick={() => NextRound()}>  <Textfit mode="single" style={{height: "100%"}}> Continue </Textfit></Button>
                   </CompleteScreen>
                   }
                   {showCompleteScreen == false &&
                        <Body updater={crossX}>
                          <div style={{ width: "80%" }}>
                          <ProgressBar percentage={power} />
                          <Button style={{position: "absolute", right: "0.5%", top: "55%", width: "200px", height: "80px", textAlign: "center", fontSize: "50px"}}onClick={() => Fire()}>FIRE</Button>

                          <Round3WordText>{currentQuestion.right_answer}</Round3WordText>
                          
                           {ReturnCursor()}
                             {ReturnGhosts()}
                         
                            {currentQuestion != undefined ? (
                              <Container update={refresh}>
                                
                              </Container>
            
                            ) : <h1>blank</h1>}
                          </div>
                        </Body>
                   }
                    </div>
                  </LearnGame>
            }
           {round == 4 &&
                     <LearnGame
                     parent={props}
                     correct={correctQuestions}
                     incorrect={incorrectQuestions}
                     score={score}
                     defaultTimer={timer}
                     questionLimit={questionMax}
                     completedAmount={completedText}
                     onBack={() => props.onBack()}
                     loading={loading}
                     feedback={feedback}
                     questionFontSize="0.7em"
                     restart={() => {
                       setCombo(0);
                       setScore(0);
                       setCorrectQuestions([]);
                       setIncorrectQuestions([]);
                     }}
                     homework_id={props.homework_id}
                   >
                     <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                       {showCompleteScreen == true &&
                    <CompleteScreen>
                        <Textfit mode="single" style={{height: "100%"}}>
                        Round {round} Complete!
                        </Textfit>
                        <Button  onClick={() => NextRound()}>  <Textfit mode="single" style={{height: "100%"}}> Continue </Textfit></Button>
                    </CompleteScreen>
                    }
                    {showCompleteScreen == false &&
                         <Body updater={crossX}>
                           <div style={{ width: "80%" }}>
                           <ProgressBar percentage={power} />
                           <Button style={{position: "absolute", right: "0.5%", top: "55%", width: "200px", height: "80px", textAlign: "center", fontSize: "50px"}}onClick={() => Fire()}>FIRE</Button>
 
                          <div>
                           <Round3WordText style={{letterSpacing: "2px"}}>{GetRound4Word()}</Round3WordText>
                           <Button style={{position: "relative", right: "-80%", top: "55%", width: "100px", height: "75px", textAlign: "center", fontSize: "50px"}}onClick={() => sayWord(currentQuestion.right_answer)}>🔊</Button>
                           </div>
                           
                            {ReturnCursor()}
                              {ReturnGhosts()}
                          
                             {currentQuestion != undefined ? (
                               <Container update={refresh}>
                                 
                               </Container>
             
                             ) : <h1>blank</h1>}
                           </div>
                         </Body>
                    }
                     </div>
                   </LearnGame>
            }

            {round == 5 &&
                <LearnGame
                parent={props}
                correct={correctQuestions}
                incorrect={incorrectQuestions}
                score={score}
                defaultTimer={timer}
                questionLimit={questionMax}
                completedAmount={completedText}
                end={endgame}
                onBack={() => props.onBack()}
                loading={loading}
                feedback={feedback}
                questionFontSize="0.7em"
                restart={() => {
                  setCombo(0);
                  setScore(0);
                  setCorrectQuestions([]);
                  setIncorrectQuestions([]);
                }}
                homework_id={props.homework_id}
              >
                <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                  {showCompleteScreen == true &&
               <CompleteScreen>
                   <Textfit mode="single" style={{height: "100%"}}>
                   Round {round} Complete!
                   </Textfit>
                   <Button  onClick={() => NextRound()}>  <Textfit mode="single" style={{height: "100%"}}> Continue </Textfit></Button>
               </CompleteScreen>
               }
               {showCompleteScreen == false &&
                    <Body updater={crossX}>
                      <div style={{ width: "80%" }}>
                      <ProgressBar percentage={power} />
                      <Button style={{position: "absolute", right: "0.5%", top: "55%", width: "200px", height: "80px", textAlign: "center", fontSize: "50px"}}onClick={() => Fire()}>FIRE</Button>

                     <div>
                      <Round3WordText style={{letterSpacing: "2px"}}>{GetRound4Word()}</Round3WordText>
                      <Button style={{position: "relative", right: "-80%", top: "55%", width: "100px", height: "75px", textAlign: "center", fontSize: "50px"}}onClick={() => sayWord(currentQuestion.right_answer)}>🔊</Button>
                      </div>
                      
                       {ReturnCursor()}
                         {ReturnGhosts()}
                     
                        {currentQuestion != undefined ? (
                          <Container update={refresh}>
                            
                          </Container>
        
                        ) : <h1>blank</h1>}
                      </div>
                    </Body>
               }
                </div>
              </LearnGame>
            }
        </div>
    );
}

const Button = styled.div`
        text-align: center;
        width: 20%;
        height: 150px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
    }
  `;

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url("${props => props.gameBackground}");
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 100px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
    margin-left: 50px;
`;

const Container = styled.div`
          width:100%%;
          height:95%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom:100px;
          `;


const CompleteScreen = styled.div`
        font-size: 100px;
        align-items: center;
        text-align: center;
        width:50%%;
        height:300px;
        background: #FFF;
        margin: 15px 25px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
          `;

const Question = styled.div`
          background: #FFF;
          width: 90%;
          height: 120px;
          line-height: 90px;
          font-size: 4em;
          margin: 15px 25px;
          text-align: center;
          border: none;
          border-radius: 10px;
          user-select: none;
        `;

  const CenteredText = styled.div`
    font-size: 26px;
    font-weight: bold;
    position: relative;
    left: -6%;
    user-select: none;
  `

  const Round3WordText = styled.div`
    font-size 40px;
    font-wight: bold;
    text-align: center;
    display: block;
    user-select: none;
    color: white;
    position: absolute;
    right: 50%;
  `


  const EmptyRune = styled.div`
        text-align: center;
        width: 100px;
        height: 150px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(200, 130, 19, 1) 0%,
          rgba(220, 170, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
    }
  `;
